<div class="card">
  <div class="card-header p-b-10">
    <div class="media-space-between">
      <h4 class="m-t-15">
        {{ title | translate }}
      </h4>
      <form
        [formGroup]="form"
        class="d-inline-flex col-10 col-xl-5 col-md-6 col-sm-8 col-xxl-4"
        style="justify-content: end;"
      >
        <app-date-range-picker
          [form]="form"
          inputFormControlName="dateChart"
        ></app-date-range-picker>
        <app-export
          class="m-l-10"
          [data]="Audience"
          [buttonName]="'export'"
          [title]="adTitle"
        ></app-export>
        <div style="margin-left: 10px">
          <app-refresh-button [state]="fetchingResultSummaryState" [date]="cachedAt" (buttonClick)="refreshChartInDate(true)"></app-refresh-button>
        </div>
        </form>
    </div>
  </div>
  <div class="card-body" id="audiences">
    <div class="row">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 col-xxl-8"
        id="invoices.summary"
      >
        <div>
          <div class="media-space-between">
            <h6 class="f-w-600 color-darkGray">
              {{ inputAudience.titleSpline ?? "" | translate }}
            </h6>
            <app-spline-filter
              [hidden]="isConsummer"
              (optionSelected)="resultOptionClicked($event)"
              [isShowClicksFilter]="conditionToShowClicks()"
            >
            </app-spline-filter>
          </div>
        </div>
        <div>
          <div class="card">
            <div class="card-body">
              <app-spline
                (chart)="chart($event)"
                [summaryChart$]="resultSummaryChart"
                [optionSelected]="optionSelected"
                [seriesTitles]="seriesTitles"
                [yaxisTitle]="yaxisTitle | translate"
                [xaxisTitle]="summaryChart.xaxisTitle | translate"
                [isAdFinished]="isAdFinished"
                [isConsumerChart]="isConsummer"
                (loadingStateChanged)="handleLoadingStateChange($event)"
                [type] ="inputAudience.type"
                [email] = "inputAudience.email"
                [resetChart] = "resetChart"
                [isShowClicks] = "conditionToShowClicks()"
              >
              </app-spline>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4"
        id="invoices.distributionAgeGender"
      >
        <div>
          <div class="media-space-between m-b-10">
            <h6 class="f-w-600 color-darkGray">
              {{ inputAudience.titleColumnChart ?? "" | translate }}
            </h6>
            <app-general-filter
              [hidden]="isConsummer"
              [filter]="filterColumnChart"
              (optionSelected)="saveOption($event)"
            ></app-general-filter>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <app-column-chart
              [xaxisTitle]="columnChart.xaxisTitle"
              [seriesTitles]="columnChart.seriesTitles"
              [yaxisTitle]="columnChart.yaxisTitle"
              [xaxisTitle]="columnChart.xaxisTitle"
              [resultGenderAgeStatics]="genderAgeStatics"
              [isLoading]="loading"
              (loadingStateChanged)="handleAgeStatsLoadingStateChanged($event)"
            >
            </app-column-chart>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn btn-primary px-3"
      style="margin-left: auto; display: block"
      *ngIf="inputAudience.title == 'Récapitulatif'"
    >
      {{ "buttons.seeStatistics" | translate }}
    </button>
  </div>
</div>
